import { parseAccountSetupPayload, type AccountSetupState } from '../../auth/domain/accountSetup';
import { saveAccountSetupOffline } from '../../shell/session/offlineAccountCache';
import { captureCatch } from '../../shared/sentry/sentryUser';

const cacheByUserId = new Map<string, AccountSetupState>();

export function clearAccountSetupCache(): void {
  cacheByUserId.clear();
}

export function primeAccountSetupFromBootstrap(userId: string, raw: unknown): void {
  let parsed: AccountSetupState | null = null;
  if (
    raw != null &&
    typeof raw === 'object' &&
    typeof (raw as AccountSetupState).requiresOwnerOnboarding === 'boolean'
  ) {
    parsed = raw as AccountSetupState;
  } else {
    parsed = parseAccountSetupPayload(raw);
  }
  if (!parsed) return;
  cacheByUserId.set(userId, parsed);
  void saveAccountSetupOffline(userId, parsed).catch(captureCatch('shell', 'account-setup-offline-save'));
}

export function getAccountSetupStateForUser(userId: string | undefined): AccountSetupState | null {
  if (!userId) return null;
  return cacheByUserId.get(userId) ?? null;
}

export function getRequiresOwnerOnboardingForUser(userId: string | undefined): boolean | null {
  if (!userId) return null;
  return cacheByUserId.get(userId)?.requiresOwnerOnboarding ?? null;
}
